export const LANGUAGE_TRANSLATIONS = [
    {
        language : "NL",
        translations : [ "Nederlands", "Néerlandais", "Dutch" ],
    },
    {
        language : "FR",
        translations : [ "Frans", "Français", "French" ],
    },
    {
        language : "EN",
        translations : [ "Engels", "Anglais", "English" ],
    },
    // Voorlopig houden we geen rekening met Duits.
    // {
    //     language : "DE",
    //     translations : [ "Duits", "Allemand", "German" ],
    // }
]
